import api from "./api";

export const getCategories = async () => {
    try {
        const response = await api.get(`/categories?populate=*`);
        // console.log(response.data.data);
        return (response.data.data);
    } catch (e) {
        console.error(e);
    }
};